<template>
  <v-app id="mnRegi" >
    <v-main>
      <v-container fluid>
        <v-row class="mt-3">
          <v-col cols="3">
            <v-text-field v-model="searchInput" label="Find website search page" prepend-inner-icon="mdi-magnify" outlined />
          </v-col>
          <v-col cols="8">

          </v-col>
          <v-col>
            <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                <span class="pr-1">Export</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="getAuth()?tableHeaders2:tableHeaders"  
          :items="filteredSearchPages" 
          :items-per-page="50" 
          class="elevation-1" 
          :loading="loading" 
          :footer-props="{'items-per-page-options': [10, 50, 100, 200]}">
          <template v-slot:item.name="{ item }">
            <v-icon>{{ typeIcon(item.type) }}</v-icon> {{ item.name }} {{ item.acco_count ? `(${item.acco_count} acco's)` : '' }}            
          </template>
          <template v-slot:item.table="{ item }" v-if="getAuth()">
            <div>(<span>table: {{item.table}}</span><span class="ml-2">key: {{ item.key }})</span></div>
          </template>
          <template v-slot:item.seo_txt="{ item }">
            <v-btn :color="item.seo_txt.nl ? '#b7e3b9' : '#ffb8b2'" small class="px-0 mr-2" @click="clickBtn('seo', item.name, item.table, item.encrid, 'NL', item.landcode)">
              <country-flag country="nl" class="mx-0 my-0"/>
            </v-btn>
            <v-btn :color="item.seo_txt.en ? '#b7e3b9' : '#ffb8b2'" small class="px-0 mr-2" @click="clickBtn('seo', item.name, item.table, item.encrid, 'EN', item.landcode)">
              <country-flag country="gb" class="mx-0 my-0"/>
            </v-btn>
            <v-btn :color="item.seo_txt.de ? '#b7e3b9' : '#ffb8b2'" small class="px-0 mr-2" @click="clickBtn('seo', item.name, item.table, item.encrid, 'DE', item.landcode)">
              <country-flag country="de" class="mx-0 my-0"/>
            </v-btn>
            <v-btn :color="item.seo_txt.fr ? '#b7e3b9' : '#ffb8b2'" small class="px-0 mr-2" @click="clickBtn('seo', item.name, item.table, item.encrid, 'FR', item.landcode)">
              <country-flag country="fr" class="mx-0 my-0"/>
            </v-btn>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
    <v-dialog v-model="showDialog" scrollable max-width="800px">
      <v-card>
        <v-card-title>{{ modalTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="useWysiwyg" style="padding:0;position: relative;">
          <v-overlay absolute color="grey lighten-1" :value="loadingAi">
            <div class="text-center">
              <div class="loading-ai-msg">Generating content with AI, please wait...</div>
              <img src="@/assets/chatGpt.svg" width="150" height="150" class="chatgpt-loading">
            </div>
          </v-overlay>
          <tiptap-vuetify v-model="seoTxt" :extensions="extensions"/>
        </v-card-text>
        <v-card-text v-else style="position: relative;">
          <v-overlay absolute color="grey" :value="loadingAi">
            <div class="loading-ai-msg input-msg">
              <img src="@/assets/chatGpt.svg" width="50" height="50" class="chatgpt-loading"> Generating content with AI, please wait...
            </div>
          </v-overlay>
          <v-text-field v-model="text" label="Content" class="mt-3" />
          Characters: {{ text.length }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn dark color="blue" @click="generateAi()" :loading="loadingAi" class="mr-2">
            Generate with AI
          </v-btn>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon> 
            </template>
            <span>Generation of AI content can take up to one minute.<br>Always double check the content that is generated</span>
          </v-tooltip>
          <v-spacer/>
          <v-btn dark color="blue" @click="showDialog = false">
            Close
          </v-btn>
          <v-btn dark color="blue" @click="saveWseo()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>

<script>
import 'tiptap-vuetify/dist/main.css'
import navBar from "@/components/ui/navbars/navbar.vue";
import { TiptapVuetify, Heading, Bold, Italic, BulletList, OrderedList, ListItem, Link, HardBreak, History } from 'tiptap-vuetify'
export default {
  components: { TiptapVuetify, navBar },
  data() {
    return {
      tableHeaders: [
        { text: 'Website search pages', value: 'name', sortable: false},
        { text: 'SEO text', value: 'seo_txt', width: '275px', sortable: false }
      ],
      tableHeaders2: [
        { text: 'Website search pages', value: 'name', sortable: false},
        { text: 'Technical info', value: 'table', sortable: false},
        { text: 'SEO text', value: 'seo_txt', width: '275px', sortable: false }
      ],      
      loading: false,
      disableExport: false,
      loadingAi: false,
      showDialog: false,
      modalTextInput: false,
      useWysiwyg: false,
      modalTitle: '',
      encrid: '',
      lang: '',
      table: '',
      text: '',
      texttype: '',
      name: '',
      landcode: '',
      extensions: [
        [Heading, {
          options: {
            levels: [2, 3]
          }
        }],
        Bold,
        Italic,
        Link,
        ListItem,
        BulletList,
        OrderedList,
        HardBreak,
        History
      ],
      seoTxt: '',
      searchInput: '',
      searchPages: []
    }
  },
  computed: {
    filteredSearchPages() {
      return this.searchPages.filter(page => {
        return page.name.toLowerCase().includes(this.searchInput.toLowerCase())
      })
    }
  },
  methods:{
    getAuth(){
      return localStorage.getItem('login')==='dennis'
    },
    typeIcon(type){
      switch(type){
        case 'country':
          return 'mdi-earth'
        case 'province':
          return 'mdi-map-outline'
        case 'place':
          return 'mdi-map-marker-outline'
        case 'ski':
          return 'mdi-ski'
        case 'touristic':
          return 'mdi-map-outline'
      }
    },
    async getWseo(){
      this.loading = true
      const getWseo = await this.$axios.post("ares/json/ares/syst/ref/wseo/getSeoTexts.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getWseo"
        }
      })
      this.searchPages = getWseo.data.getWseo
      this.loading = false
    },
    async clickBtn(texttype, name, table, encrid, lang, landcode){
      this.encrid = ''
      this.lang = ''
      this.table = ''
      this.seoTxt = ''
      this.text = ''
      this.texttype = texttype
      this.name = name
      this.landcode = landcode
      this.useWysiwyg = !!(this.texttype === 'seo')
      switch(texttype){
        case 'title':
          this.modalTitle = `${lang} page title: ${name}`
          break
        case 'meta':
          this.modalTitle = `${lang} meta description: ${name}`
          break
        case 'seo':
          this.modalTitle = `${lang} SEO text: ${name}`
          break
      }
      this.showDialog = true
      const getWseoTxt = await this.$axios.post("ares/json/ares/syst/ref/wseo/getSeoText.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getWseo"
        },
        getWseo: {
          texttype: this.texttype,
          table: table,
          encrid: encrid,
          lang: lang
        }
      })
      this.texttype = getWseoTxt.data.getWseo.texttype
      if(this.texttype === 'seo'){
        this.seoTxt = getWseoTxt.data.getWseo.text
      } else {
        this.text = getWseoTxt.data.getWseo.text
      }
      this.encrid = getWseoTxt.data.getWseo.encrid
      this.lang = getWseoTxt.data.getWseo.lang
      this.table = getWseoTxt.data.getWseo.table
    },
    async saveWseo(){
      if(this.loadingAi){ return }
      const saveWseo = await this.$axios.post("ares/json/ares/syst/ref/wseo/saveSeoText.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "saveWseo"
        },
        saveWseo: {
          table: this.table,
          encrid: this.encrid,
          lang: this.lang,
          texttype: this.texttype,
          text: this.texttype === 'seo' ? this.seoTxt !== '<p></p>' ? this.seoTxt : '' : this.text
        }
      })
      if(saveWseo.data.saveWseo.saved){
        this.getWseo()
        this.showDialog = false
      }
    },
    async generateAi(){
      this.loadingAi = true
      let prompt = ''
      let responseLang = 'Nederlands'
      switch(this.lang){
        case 'EN':
          responseLang = 'Engels'
          break
        case 'DE':
          responseLang = 'Duits'
          break
        case 'FR':
          responseLang = 'Frans'
          break
      }
      let country = ''
      switch(this.landcode){
        case 'NL':
          country = 'Nederland'
          break
        case 'DE':
          country = 'Duitsland'
          break
        case 'FR':  
          country = 'Frankrijk'
          break
        case 'AT':
          country = 'Oostenrijk'
          break
        case 'BE':
          country = 'België'
          break
      }
      switch(this.table){
        case 'land':
          if(this.texttype === 'title'){
            prompt = `Schrijf pagina titel voor een pagina over het land ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}.`
          }
          if(this.texttype === 'meta'){
            prompt = `Schrijf een meta description tag voor een pagina over het land ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Laat alleen de tekst zien die in het content atribuut moet komen.`
          }
          if(this.texttype === 'seo'){
            prompt = `Schrijf een SEO geoptimaliseerde tekst voor een pagina over het land ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Maak van de tekst html en gebruik alleen p tags en b tags. Laat de html tag weg.`
          }
          break
        case 'prov':
          if(this.texttype === 'title'){
            prompt = `Schrijf pagina titel voor een pagina over de provincie ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}.`
          }
          if(this.texttype === 'meta'){
            prompt = `Schrijf een meta description tag over de provincie ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Laat alleen de tekst zien die in het content atribuut moet komen.`
          }
          if(this.texttype === 'seo'){
            prompt = `Schrijf een SEO geoptimaliseerde tekst voor een pagina over de provincie ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Maak van de tekst html en gebruik alleen p tags en b tags. Laat de html tag weg.`
          }
          break
        case 'regi':
          if(this.texttype === 'title'){
            prompt = `Schrijf pagina titel voor een pagina over ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}.`
          }
          if(this.texttype === 'meta'){
            prompt = `Schrijf een meta description tag over ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Laat alleen de tekst zien die in het content atribuut moet komen.`
          }
          if(this.texttype === 'seo'){
            prompt = `Schrijf een SEO geoptimaliseerde tekst voor een pagina over ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Maak van de tekst html en gebruik alleen p tags en b tags. Laat de html tag weg.`
          }
          break
        case 'plts':
          if(this.texttype === 'title'){
            prompt = `Schrijf pagina titel voor een pagina over de plaats ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}.`
          }
          if(this.texttype === 'meta'){
            prompt = `Schrijf een meta description tag voor een pagina over de plaats ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Laat alleen de tekst zien die in het content atribuut moet komen.`
          }
          if(this.texttype === 'seo'){
            prompt = `Schrijf een SEO geoptimaliseerde tekst voor een pagina over de plaats ${this.name} in ${country} voor op de website van Villa for You. Schrijf de tekst in het ${responseLang}. Maak van de tekst html en gebruik alleen p tags en b tags. Laat de html tag weg.`
          }
          break
      }
      if(prompt){
        const generateAi = await this.$axios.post("https://api.villaforyou.com/askChatGpt", { prompt })
        if(this.texttype === 'seo'){
          this.seoTxt = generateAi.data
        }else{
          this.text = generateAi.data
        }
      }
      this.loadingAi = false
    },
    async buildReport() {
        this.disableExport = true;
        this.$axios.post("ares/json/ares/syst/ref/wseo/getSeoTextsXlsx.p", {
            header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "getSeoTextsXlsx"
            },
            getSeoTextsXlsx: {
            }
        }).then(res => {
            if (res.data.error) {
                console.log(res.data.error);
            } else {
                window.open(res.data.getSeoTextsXlsx.filename, '_blank');
            }
            this.disableExport = false;
        });
    },
  },
  mounted() {
    this.getWseo()
  }
}
</script>

<style scoped>
.loading-ai-msg{
  color: rgb(41, 41, 41);
  font-weight: bold;
  font-size: 24px;
}
.input-msg{
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding-right: 10px;
  font-size: 18px;
}
.chatgpt-loading{
  animation-name: rotateSvg;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  opacity: 0.7;
}
@keyframes rotateSvg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<style>
.tiptap-vuetify-editor__content{
  height: 560px;
}
</style>
